<template>
  <div class="cb-map-wrap">
    <!-- 顶部导航 -->
    <div class="top-header-area">
      <TopHeader2 />
    </div>
    
    <!-- 主体内容 -->
    <div class="main-content">
     <LeftPanel />

      <!-- 中间区域 - 三个区域 -->
      <div class="center-area">
       
        
        <!-- 第二块：中国地图 -->
        <div class="center-section center-section-2 border-box">
          <!-- <CenterMap /> -->
          <ContentMap />
        </div>
        
        <!-- 第三块：底部统计 -->
        <div class="center-section center-section-3 border-box">
          <CenterBottomStats />
        </div>
      </div>

      <!-- 右侧面板 - 三个区域 -->
      <RightPanel />
    </div>
  </div>
</template>

<script>
import { getTime } from "@/utils";
import TopHeader2 from "./map/TopHeader2.vue";
import LeftPanel from "./left2/LeftPanel.vue";
import RightPanel from "./right2/RightPanel.vue";
import CenterBottomStats from "./center2/CenterBottomStats.vue";
import ContentMap from "./center2/contentMap.vue";
// import CenterMap from "../../components/map/CenterMap.vue";

export default {
  name: 'MapScreen',
  components: {
    TopHeader2,
    LeftPanel,
    RightPanel,
    CenterBottomStats,
    ContentMap,
    // CenterMap
  },
  data() {
    return {
      currentDateTime: '',
      activeTab: 'all',
      
    }
  },
  mounted() {
    this.updateDateTime()
    this.timer = setInterval(this.updateDateTime, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    updateDateTime() {
      this.currentDateTime = getTime()
    },
    formatNumber(num) {
      return Number(num).toLocaleString()
    },
    refreshData() {
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'index2.scss';
</style>
